// Grouping for the two print views.
//
// The screen Gantt groups by contractor, area, discipline or stage; a
// printed programme that can only be read in plan order is the same
// schedule with the useful cuts taken away. This produces ONE flat row
// list with header rows mixed in, so each page keeps its existing row
// renderer and only has to answer "is this a header?".
//
// A header row is { groupKey, groupLabel } and carries no `item`.

export const PRINT_GROUPS = [
  { value: "wbs", label: "Plan structure" },
  { value: "area", label: "Area" },
  { value: "discipline", label: "Discipline" },
  { value: "stage", label: "Stage" },
  { value: "company", label: "Contractor" },
];

// area reads the REFERENCE first and falls back to the free text, so a
// project that has not drawn its areas still groups by what it typed.
const KEY_OF = {
  area: (it) => (it.areaId ? `id:${String(it.areaId)}` : (it.areaKey ? `txt:${it.areaKey}` : "")),
  discipline: (it) => it.discipline || "",
  stage: (it) => it.stage || "",
  company: (it) => String(it.responsibleCompanyId || ""),
};

export function groupRows(rows, mode, labels = {}) {
  const keyOf = KEY_OF[mode];
  if (!keyOf) return rows;

  const lanes = new Map();
  for (const r of rows) {
    if (!r.item) continue;
    const k = String(keyOf(r.item) || "");
    if (!lanes.has(k)) lanes.set(k, []);
    lanes.get(k).push(r);
  }
  const keys = [...lanes.keys()].filter((k) => k !== "");
  if (lanes.has("")) keys.push("");

  const out = [];
  for (const k of keys) {
    let label = "Unassigned";
    if (k) {
      if (mode === "area") {
        label = k.startsWith("id:")
          ? (labels.areas?.[k.slice(3)] || lanes.get(k)[0]?.item?.areaKey || "Area")
          : k.slice(4);
      } else if (mode === "stage") label = labels.stages?.[k] || k;
      else if (mode === "company") label = labels.companies?.[k] || k;
      else label = k;
    }
    out.push({ groupKey: `${mode}-${k || "unassigned"}`, groupLabel: `${label} (${lanes.get(k).length})` });
    // Inside a lane the plan's own nesting no longer means anything -
    // the rows come from all over the tree - so they print flat.
    for (const r of lanes.get(k)) out.push({ ...r, depth: 0 });
  }
  return out;
}
